export const splitPascalCase = (value?: string): string => {
  if (!value) return '';
  return value.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, (c) => c.toUpperCase()); // ensure first letter capitalized
};
